import { HZ_CIRCLE, Hazard } from "../entities/hazard.ts";
import { circlesOverlap } from "../core/vec.ts";

/** Circle (cx,cy,cr) vs oriented box centered at (bx,by) with half-extents,
 * rotated by `angle`. Transforms the circle center into the box's local frame
 * and measures distance to the clamped closest point. */
export function circleVsOBB(
  cx: number,
  cy: number,
  cr: number,
  bx: number,
  by: number,
  hw: number,
  hh: number,
  angle: number,
): boolean {
  const dx = cx - bx;
  const dy = cy - by;
  const cos = Math.cos(-angle);
  const sin = Math.sin(-angle);
  // Circle center in box-local space.
  const lx = dx * cos - dy * sin;
  const ly = dx * sin + dy * cos;
  // Closest point on the box to the (local) circle center.
  const closestX = lx < -hw ? -hw : lx > hw ? hw : lx;
  const closestY = ly < -hh ? -hh : ly > hh ? hh : ly;
  const ddx = lx - closestX;
  const ddy = ly - closestY;
  return ddx * ddx + ddy * ddy <= cr * cr;
}

/** Does the player hit-circle collide with this (active) hazard? */
export function hazardHitsCircle(h: Hazard, cx: number, cy: number, cr: number): boolean {
  if (h.kind === HZ_CIRCLE) {
    return circlesOverlap(cx, cy, cr, h.x, h.y, h.radius);
  }
  return circleVsOBB(cx, cy, cr, h.x, h.y, h.hw, h.hh, h.angle);
}
